import React from 'react'
import AnimatedPage from '../components/AnimatedPage';
import { about } from '../data/about';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub, faLinkedin, faDev } from "@fortawesome/free-brands-svg-icons"
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';

export default function About() {
    let info = about;

  return (
    <AnimatedPage>
        <div className="w-full min-h-screen">
        <div className="mxw-sm w-full my-12 relative">
            <h2 className="text-4xl md:text-6xl lg:text-6xl font-bold gradient__text">Hello There.</h2>
        </div>
        <section className="animate animate__animated animate__fadeIn mxw-sm">
            <div className="grid gap-6 grid-cols-1 sm:grid-cols-5">
                <div className="sm:col-span-1">
                    <img className="h-full w-full 4 object-cover rounded-lg shrink-0" src={info?.avatar} />
                </div>
                <div className="sm:col-span-4 flex flex-col items-start justify-center space-y-3">
                    <h2 className="text-2xl text-white">{info?.bioIntro}</h2>
                    <p className="text-xl text-white font-thin">{info?.bioPreface}</p>
                    <div className="flex items-center flex-wrap justify-start">
                        <a target="_blank" rel="noreferrer" href={info?.github} className="inline-block mr-2 my-1 text-white font-semibold">
                         <FontAwesomeIcon icon={faGithub} />
                        </a>
                        <a target="_blank" rel="noreferrer" href={info?.linkedin} className="inline-block mr-2 my-1 text-white font-semibold">
                         <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a target="_blank" rel="noreferrer" href={info?.dev} className="inline-block mr-2 my-1 text-white font-semibold ">
                         <FontAwesomeIcon icon={faDev} />
                        </a>
                        <a target="_blank" rel="noreferrer" href={info?.leetcode} className="inline-block mr-2 my-1 text-white font-semibold ">
                         <FontAwesomeIcon icon={faLaptopCode} />
                        </a>
                    </div>
                </div>
            </div>
        </section>  
        <div className="w-full my-12 max-w-[200px] mx-auto h-3" />
        <section className="mxw-sm my-12">
            {/* <p className="text-xl md:text-xl text-white font-light">{info?.bioSub}</p> */}
            {/* skills  */}
            {/* <p className="text-2xl md:text-3xl my-12 blog_text">Skills include:</p>
            <div className="flex items-center flex-wrap">
                {about?.skills?.map((skill) => (
                    <span className="py-2 px-3 my-1 mx-2 shadow-lg gradient__bg2 text-white font-semibold">{skill?.name}</span>
                ))}
            </div> */}
            {/* <p className="text-xl md:text-xl py-6">{info?.bioMain}</p> */}
        </section>
    </div>
    </AnimatedPage>
  )
}
